module.exports = __webpack_public_path__ + "media/images/img_top_menu_3-bed04cadcb06ca28ede8fc05c9816bd9.png";